module.exports = __webpack_public_path__ + "img/1_5.5e901146.png";